module.exports = __webpack_public_path__ + "static/media/emj10.0137ab6c.svg";